/* eslint-disable jsx-a11y/iframe-has-title */
import { useGetFigureflowInterface } from "../../../hooks/api/queries/useFigureflow";
import secondaryComponents from "../../../components/secondaryComponents";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";

const AIAssistance = () => {
  const { data, isLoading } = useGetFigureflowInterface();

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <h4>AI ASSISTANCE</h4>

      <secondaryComponents.LoaderHelper
        isLoading={isLoading}
        classNames={"mt-5"}
      >
        <div
          style={{
            width: "100%",
            height: "600px",
            boxShadow: "0 4px 24px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            borderRadius: "16px",
          }}
        >
          {data?.token ? (
            <iframe
              src={`https://stg3.figureflow.app/embed/lumi?token=${data?.token}&primary=#7647ee`}
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          ) : (
            <div>
              <h5>Opps! Something went wrong, please try again</h5>
            </div>
          )}
        </div>
      </secondaryComponents.LoaderHelper>
    </div>
  );
};

export default AIAssistance;
